import {
  BaseField,
  buildForm,
  Button,
  ClickToCopy,
  Form,
  SubmitButton,
} from "@bleu.builders/ui";
import React from "react";
import { useForm } from "react-hook-form";

import { Link } from "#/components/Link";
import { AddResourceCardWrapper } from "#/pages/(components)/AddResourceModal";

export function CreationInProgress({
  title,
  description,
  path,
  fields,
  form,
  state,
  handleSubmit,
}: {
  title: string;
  description: string;
  path: string;
  fields: BaseField[];
  form: ReturnType<typeof useForm>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any;
  handleSubmit: () => () => void;
}) {
  return (
    <AddResourceCardWrapper title={title} description={description}>
      <Form action={path} method="post" className="space-y-4" {...form}>
        {buildForm(fields, form)}
        <div className="flex flex-col gap-y-2">
          <Link to="/settings/brand_theme" className="w-full">
            <Button type="button" variant="outline" className="w-full">
              Personalize seu relatório de diagnóstico
            </Button>
          </Link>
          <SubmitButton
            type="button"
            onClick={handleSubmit()}
            submittingText="Gerando link..."
            isSubmitting={state.value === "creationInProgress"}
            className="w-full"
          >
            Gerar link para cadastro
          </SubmitButton>
        </div>
      </Form>
    </AddResourceCardWrapper>
  );
}

export function SuccessCreation({
  title = "Diagnóstico externo criado",
  resourceTitle,
  state,
}: {
  title?: string;
  resourceTitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  state: any;
}) {
  return (
    <AddResourceCardWrapper
      title="Diagnóstico externo criado"
      description="Aqui está o link para o seu diagnóstico."
    >
      <span className="flex mt-3 gap-1">
        {title}
        {resourceTitle && <p className="font-bold">"{resourceTitle}".</p>}
      </span>
      <div className="flex flex-col gap-1 mt-4">
        <span className="text-foreground">Link externo do diagnóstico</span>
        <a
          href={state.context.externalUrl}
          className="text-primary text-xs underline"
        >
          {state.context.externalUrl}
        </a>
        <ClickToCopy
          className="mt-1 rounded-md text-sm font-medium px-2 py-1 border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground w-fit"
          text={state.context.externalUrl}
        >
          Copiar link
        </ClickToCopy>
      </div>
    </AddResourceCardWrapper>
  );
}

export function CreationError({
  title,
  description,
  creationError,
}: {
  title: string;
  description: string;
  creationError: string;
}) {
  return (
    <AddResourceCardWrapper title={title} description={description}>
      <p>{creationError}</p>
    </AddResourceCardWrapper>
  );
}
